import { render, staticRenderFns } from "./WorkspaceConfiguration.vue?vue&type=template&id=134c35dc&scoped=true&"
import script from "./WorkspaceConfiguration.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134c35dc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('134c35dc')) {
      api.createRecord('134c35dc', component.options)
    } else {
      api.reload('134c35dc', component.options)
    }
    module.hot.accept("./WorkspaceConfiguration.vue?vue&type=template&id=134c35dc&scoped=true&", function () {
      api.rerender('134c35dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/policies/WorkspaceConfiguration.vue"
export default component.exports